import {useParams, useSearchParams} from "react-router-dom";
import {Tabs} from "antd";
import {PageHeader, ProjectQuota, ProjectToolNav} from "~/components";
import {useCan} from "~/hooks";
import KeywordExplorer from "../components/KeywordExplorer";
import KeywordOpportunities from "../components/KeywordOpportunities";
import KeywordIdeas from "../components/KeywordIdeas";
import KeywordGoogleIdeas from "../components/KeywordGoogleIdeas";
import KeywordGap from "../components/KeywordGap";
import KeywordSiteGap from "../components/KeywordSiteGap";
import KeywordTrending from "../components/KeywordTrending";
import KeywordVault from "../components/KeywordVault";

/**
 * Trang tool Nghiên cứu từ khoá của một dự án (`/projects/:id/keywords`).
 *
 *  - Khám phá      : kho query GSC của dự án (impressions thật thay "search volume") + lọc + lưu.
 *  - Cơ hội        : gần trang 1 / CTR thấp bất thường / cụm chủ đề tiềm năng (từ GSC 90 ngày).
 *  - Ý tưởng AI    : AI xây cụm ý tưởng + đối chiếu ngược GSC (badge số liệu thật).
 *  - Gợi ý Google  : Google Keyword Planner sinh từ khoá MỚI kèm volume/CPC thật (1 lượt tra/lần).
 *  - Phân tích trang: trích cụm từ 1 URL (mình/đối thủ) + Content gap — gate cờ gói can_keyword_gap.
 *  - Gap cấp site  : thiếu bài viết + thiếu internal link (#28 — TOP query GSC × trang đã crawl, thuần DB).
 *  - Xu hướng      : từ khoá đang trending trên Google Trends (tái dùng tool /trends) — lưu thẳng vào kho.
 *  - Kho từ khoá   : danh sách đã lưu (nguồn gsc/ai/content/manual/trends/google_ads) + số liệu hiện tại.
 */
function KeywordHome() {

	const {id} = useParams();
	const canKeyword = useCan('keyword');
	// Deep-link tab qua ?tab= (vd. tab Phân tích của GSC dẫn sang ?tab=opportunities).
	const [searchParams] = useSearchParams();

	if (!canKeyword) return <div className="container">Bạn không có quyền sử dụng Nghiên cứu từ khoá.</div>;

	const items = [
		{key: 'explore', label: 'Khám phá', children: <KeywordExplorer projectId={id} />},
		{key: 'opportunities', label: 'Cơ hội', children: <KeywordOpportunities projectId={id} />},
		{key: 'ideas', label: 'Ý tưởng AI', children: <KeywordIdeas projectId={id} />},
		{key: 'google-ideas', label: 'Gợi ý Google', children: <KeywordGoogleIdeas projectId={id} />},
		{key: 'gap', label: 'Phân tích trang', children: <KeywordGap projectId={id} />},
		{key: 'site-gap', label: 'Gap cấp site', children: <KeywordSiteGap projectId={id} />},
		{key: 'trending', label: 'Xu hướng', children: <KeywordTrending projectId={id} />},
		{key: 'vault', label: 'Kho từ khoá', children: <KeywordVault projectId={id} />},
	];

	const tab = searchParams.get('tab');
	const defaultTab = items.some((it) => it.key === tab) ? tab : 'explore';

	return (
		<div className="container">
			<ProjectToolNav projectId={id} active="keywords" />

			<PageHeader
				icon="fa-light fa-tags"
				title="Nghiên cứu từ khoá"
				subtitle="Khám phá từ khoá từ dữ liệu Search Console thật của dự án + kho từ khoá đã lưu"
				actions={<ProjectQuota tool="keywords" />}
			/>

			<Tabs items={items} defaultActiveKey={defaultTab} />
		</div>
	);
}

export default KeywordHome;
